import type { App } from "vue";

// import { useStore } from "@/store";

// import { PermissionAdminCode } from "@/enums/ConfigEnum";

// interface Config {
//   projectId?: number;
// }

// export function hasPermission(value: string[], config?: Config) {
//   const store = useStore();

//   const currentProjectId = store.state.config.currentProjectId;

//   const projectId = Number(config?.projectId || currentProjectId || "") || 0;

//   const permissionCodes = store.state.permission.permissionCodes;

//   const projectCodes = store.state.permission.projectCodes;

//   const projectPower =
//     projectCodes.find((i) => i.projectId === projectId)?.power || [];

//   // 管理员账号
//   if (permissionCodes.includes(PermissionAdminCode)) return true;

//   // 系统角色权限
//   if (value && value instanceof Array && value.length > 0) {
//     const hasPermission = value.some((role) => {
//       // 系统角色
//       let codes = permissionCodes;
//       // 项目角色
//       if (projectId && projectPower.length) {
//         if (projectPower.includes(PermissionAdminCode)) return true;
//         codes = projectPower;
//       }
//       return role && codes.includes(role);
//     });
//     return hasPermission;
//   } else {
//     console.info(`need roles! Like v-permission="['admin','editor']"`);
//   }
//   return false;
// }

export default function (app: App) {
  app.directive("permission", {
    mounted: (el, bind) => {
      /**
       * 自定义指令
       */
      log.info(el, bind);
      // const { value } = bind;
      // const lastItem = value[value.length - 1];
      // let config: Config = {};
      // if (isObject(lastItem)) {
      //   config = lastItem as Config;
      //   value.pop();
      // }
      // if (!hasPermission(value, config)) {
      //   el.parentNode && el.parentNode.removeChild(el);
      // }
    },
  });
}
